/*
 * This code was generated with assistance from GitHub Copilot.
 * De-bundled from react-dxd-components@0.1.33 compiled dist/index.js (webpack module id 34).
 */
import * as React from 'react';
import type { HTMLAttributes } from 'react';
import classNames from './classnames-vendor';
import { NavigationItem } from './NavigationItemConstants';
import SiteNavigationItem from './SiteNavigationItem';

export interface SiteNavigationProps extends HTMLAttributes<HTMLElement> {
  /**
   * Application display name to show left-aligned in the nav bar
   */
  applicationName?: string;
  /**
   * Nav items that should appear left-aligned in the nav bar
   */
  mainItems?: NavigationItem[];
  /**
   * Nav items that should appear right-aligned in the nav bar
   */
  utilityItems?: NavigationItem[];
  /**
   * By default will max width at 1600px, this prop allows override to stretch nav
   * across whole width of screen at larger sizes
   */
  fullWidth?: boolean;
  className?: string;
}

const SiteNavigation = ({
  applicationName,
  mainItems = [],
  utilityItems = [],
  fullWidth = false,
  className,
  ...otherProps
}: SiteNavigationProps) => {
  const rootClasses = classNames('NavigationContainer', className);
  const siteNavClasses = classNames('SiteNav', { 'SiteNav--full': fullWidth });

  const hasMainItems = mainItems.length > 0;
  const hasUtilityItems = utilityItems.length > 0;
  const hasItems = hasMainItems || hasUtilityItems;

  return (
    <header id="nav" className={rootClasses} {...otherProps}>
      <div className="Navigation NavigationContainer-container">
        {applicationName && <div className="SiteNav-siteName">{applicationName}</div>}
        <nav className="MobileNav">
          {hasItems && (
            <>
              <a href="#" className="MobileNav-menu">
                Menu
              </a>
              <a href="#" className="MobileNav-menu-open">
                Close
              </a>
            </>
          )}
        </nav>
        <div className="SiteNav-container">
          {hasMainItems && (
            <nav className={siteNavClasses} role="menubar">
              {mainItems.map((item, index) => (
                <SiteNavigationItem key={item.title} index={index} item={item} />
              ))}
            </nav>
          )}
          {hasUtilityItems && (
            <nav className="SiteNav--utility">
              <div className="SiteNav--utility-container">
                {utilityItems.map((item, index) => (
                  <SiteNavigationItem key={item.title} index={index} item={item} />
                ))}
              </div>
            </nav>
          )}
        </div>
      </div>
    </header>
  );
};

export default SiteNavigation;


